import type { IconSource } from '@shopify/polaris';

import {
  BlogIcon,
  CartIcon,
  CollectionIcon,
  HomeIcon,
  PageIcon,
  ProductIcon,
} from '@shopify/polaris-icons';
import { TemplateType } from '~/types/template';

export interface IPageCategory {
  id: string;
  label: string;
  icon: IconSource;
  /** TemplateTypes whose pages populate this category's children */
  type: TemplateType;
  /** If true, category is a leaf (no drill-down) — shows first matching page directly */
  leaf?: boolean;
  /** For leaf categories: exact path to match instead of using first page from type pool */
  exactPath?: string;
}

export const PAGE_CATEGORY_GROUPS: Array<{ items: IPageCategory[] }> = [
  {
    items: [
      { id: '/', label: 'Home page', icon: HomeIcon, type: TemplateType.HOME, leaf: true },
      { id: '/pages', label: 'Landing pages', icon: PageIcon, type: TemplateType.PAGE },
      { id: '/products', label: 'Products', icon: ProductIcon, type: TemplateType.PRODUCT },
      {
        id: '/collections',
        label: 'Collections',
        icon: CollectionIcon,
        type: TemplateType.COLLECTION,
      },
      { id: '/blogs', label: 'Blog posts', icon: BlogIcon, type: TemplateType.ARTICLE },
    ],
  },
  {
    items: [
      { id: '/blogs/all', label: 'Blogs', icon: BlogIcon, type: TemplateType.BLOG },
      {
        id: '/collections/all',
        label: 'Collections list',
        icon: CollectionIcon,
        type: TemplateType.COLLECTION_LIST,
        leaf: true,
        exactPath: '/collections/all',
      },
    ],
  },
  {
    items: [{ id: '/cart', label: 'Cart', icon: CartIcon, type: TemplateType.CART, leaf: true }],
  },
];
